
import React from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';

interface ComparisonData {
  feature: string;
  cutshort: string;
  naukri: string;
  linkedin: string;
  agencies: string;
}

export const ComparisonSection = () => {
  const comparisonData: ComparisonData[] = [
    {
      feature: "Talent Pool",
      cutshort: "Premium tech with deep skill info",
      naukri: "Generic with skill details",
      linkedin: "Generic without skill details",
      agencies: "N/A"
    },
    {
      feature: "Contacts & intent",
      cutshort: "Yes",
      naukri: "Yes",
      linkedin: "No",
      agencies: "Yes"
    },
    {
      feature: "Sourcing effort",
      cutshort: "80% less with AI Agents",
      naukri: "High",
      linkedin: "High",
      agencies: "Low"
    },
    {
      feature: "Pricing models",
      cutshort: "Save 40%. Pay when you hire model available.",
      naukri: "High",
      linkedin: "High",
      agencies: "Very costly"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-darkgrey text-center mb-6">
            How Cutshort compares
          </h2>
          <p className="text-xl text-center text-brand-grey mb-12">
            The only platform that brings 3.5M+ premium candidates with AI working 24x7 for you.
          </p>
          
          <div className="overflow-x-auto">
            <Table className="w-full border-collapse">
              <TableHeader>
                <TableRow className="bg-blue-100">
                  <TableHead className="w-1/5 p-4 text-left font-semibold">Feature</TableHead>
                  <TableHead className="w-1/5 p-4 text-left font-semibold">Cutshort</TableHead>
                  <TableHead className="w-1/5 p-4 text-left font-semibold">Naukri</TableHead>
                  <TableHead className="w-1/5 p-4 text-left font-semibold">LinkedIn</TableHead>
                  <TableHead className="w-1/5 p-4 text-left font-semibold">Agencies</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((row, index) => (
                  <TableRow key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <TableCell className="p-4 font-medium">{row.feature}</TableCell>
                    <TableCell className="p-4">{row.cutshort}</TableCell>
                    <TableCell className="p-4">{row.naukri}</TableCell>
                    <TableCell className="p-4">{row.linkedin}</TableCell>
                    <TableCell className="p-4">{row.agencies}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </section>
  );
};
